import * as R from 'ramda';
import { useState } from 'react';
// helpers/constants
import * as G from '../helpers';
//////////////////////////////////////////////////

const useUIFilters = ({
  report,
  itemList,
  filterProps,
  callbackData,
  shouldUseUIFilters,
}) => {
  const [uiFilters, setUIFilters] = useState({});
  const [uiSorting, setUISorting] = useState({});

  let filteredItemList = itemList;

  if (R.and(shouldUseUIFilters, G.isNotNilAndNotEmpty(uiFilters))) {
    filteredItemList = G.getItemListFilteredByUiTableTitleFilters(
      report,
      itemList,
      uiFilters,
      callbackData,
    );
  }

  if (R.and(shouldUseUIFilters, G.isNotNilAndNotEmpty(uiSorting))) {
    filteredItemList = G.getItemListSortedByUITableSorting(
      report,
      uiSorting,
      filterProps,
      filteredItemList,
      callbackData,
    );
  }

  return {
    uiFilters,
    uiSorting,
    setUIFilters,
    setUISorting,
    filteredItemList,
  };
};

export default useUIFilters;
